export default __webpack_public_path__ + "media/zurb/img/mobile-and-web-apps/equinix_stats-b369ee6bfa11ac102a873dd549883825.png";